import React from 'react';
import {
  Button,
  Layout,
  Row,
  Collapse,
  Comment,
  Tooltip,
  Col,
  message,
  Modal,
  Empty,
  Skeleton,
  Avatar,
} from 'antd';
import ReactQuill from "react-quill";
import moment from "moment";
import MiCompAPI from '../../util/api';
import img from '../../assets/img/At the office-pana 1.png';
import Adddiscussion from './Adddiscussion';
const { Panel } = Collapse;
const { Content } = Layout;
const { confirm } = Modal;

export default class Discussion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      discussions: [],
      addDiscussionActive: false,
      discussion: null,
      addReply: '',
      editReplyActive: null,
      isLoading: false
    }
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  componentDidMount() {
    this.GetDiscussionItems();
  }
  addDiscussionDefaultHandler = () => {
    this.setState({ addDiscussionActive: !this.state.addDiscussionActive,  discussion: null
    });
  };
  EditDiscussion = (val) => {
    this.setState({
      addDiscussionActive: true,
      discussion: val
    });
  };

  GetDiscussionItems() {
    this.setState({
      isLoading: true
  })
    this.api.invoke("GetDiscussionItems", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({
            discussions: data.data,
            replie: data.data.replies,
          });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
        this.setState({
          isLoading: false
      })
      }
    });
  }
  addDiscusionSubmitHandler = (data) => {
    this.api.invoke(
      "CreateDiscussion",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({ addDiscussionActive: false });
            this.GetDiscussionItems();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
            this.addDiscussionDefaultHandler();
          }
        } else {
          message.destroy();
          message.error("Add Discussion failed. Contact Support", 3);
        }
      },
      data
    );
  };
  addReplySubmitHandler = (data) => {
    if(!this.state.addReply||this.state.addReply.trim()===""){
      message.destroy();
      message.info("Please type a message to continue",3)
      return;
        }
    this.api.invoke(
      "AddReply",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({
              addReply: '',

            });
            this.GetDiscussionItems();

          } else {
            message.destroy();
            message.error(data.statusMessage, 3);

          }
        } else {
          message.destroy();
          message.error("Add Reply failed. Contact Support", 3);
        }
      },
      data
    );
  };
  CloseDiscussion = (id) => {
    confirm({
      title: "Do you want to close this Discussion?",
      onOk: () => {
        this.api.invoke(
          "CloseDiscussion/" + id,
          "patch",
          (data, success) => {
            if (success) {
              if (data.statusCode === 200) {
                message.destroy();
                message.success(data.statusMessage, 3);
                this.GetDiscussionItems();
              } else {
                message.destroy();
                message.error(data.statusMessage, 3);
              }
              
            }
          }
        );
      },
      okText: "Yes",
      cancelText: "No",
      onCancel() { },

    });
  }
  removeDiscussion = (id) => {
    confirm({
      title: "Do you want to delete this Discussion?",
      onOk: () => {
        this.api.invoke(
          "DeleteDiscussionbyId/" + id,
          "delete",
          (data, success) => {
            if (success) {
              if (data.statusCode === 200) {
                message.destroy();
                message.success(data.statusMessage, 3);
                this.GetDiscussionItems();
              } else {
                message.destroy();
                message.error(data.statusMessage, 3);
              }
              
            }
          }
        );
      },
      okText: "Yes",
      cancelText: "No",
      onCancel() { },

    });
  }
  removeReply = (id) => {
    confirm({
      title: "Do you want to delete this Reply?",
      onOk: () => {
        this.api.invoke(
          "DeleteReplaybyId/" + id,
          "delete",
          (data, success) => {
            if (success) {
              if (data.statusCode === 200) {
                message.destroy();
                message.success(data.statusMessage, 3);
                this.GetDiscussionItems();
              } else {
                message.destroy();
                message.error(data.statusMessage, 3);
              }
             
            }
          }
        );
      },
      okText: "Yes",
      cancelText: "No",
      onCancel() { },
    });
  }
  render() {    
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    return (
      <Content>
        <div className="mi_main_div">
          <Content lo>
            <div className="mi_main_div" style={{ paddingLeft: "10px" ,paddingRight:"10px"}}>
              <div className="mi_box">
                <Row span={24}>
                  <Col span={18}>
                    <h4 className="mi_box_h4">Discussion Board</h4>
                  </Col>
                  <Col span={6}>
                    <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
                  </Col>
                </Row>
              </div>
              <Row span={24}>
                <Col span={24} >
                  {role === "carrier" || role === "agency" ? (<Button type="primary" className="submit-button" onClick={this.addDiscussionDefaultHandler} style={{ float: 'right' }}>
                    Create Discussion</Button>) : (<></>)}

                </Col>
              </Row>
              
              {this.state.discussions && this.state.discussions.length > 0 ? this.state.discussions.map(tag => {
                return <Comment style={{ backgroundColor: "white", marginTop: '10px', padding: '30px', border: '1px solid #d9d9d9', borderRadius: '10px' }}
                 
                author={   <p className="mi_table_title"> {tag.topic}</p>}
                  avatar={
                    <Avatar
                      alt="Han Solo"
                      style={{ backgroundColor: '#4e5694',marginTop:"5px" }}
                    >{tag.user.split(' ').map((item) => item.charAt(0)).join('').toUpperCase()}</Avatar>
                  }
                 
                  content={
                    <div>                                       
                      <Row>                        
                        <Col span={20}>
                        <a style={{ fontWeight: 'bold', fontSize: '18px', color: ' rgba(0, 0, 0, 0.65)'}}>
                          {tag.user}
                          </a>
                          <p className="ant-table-column-title">
                            {tag.description}
                          </p>
                          {tag.document_Name&&tag.unq_Document_Name&&
                          <i className='mi_table_title fa  fa-file fa-6x' style={{fontSize:'26px'}} onClick={()=>{        window.open(tag.unq_Document_Name, "_blank")}}  aria-hidden="true"> {tag.document_Name}</i>

                         }
                        </Col>
                      {!tag.isClosed&&<Col span={4}>
                        {/* {!tag.hasAccess ? (<></>) : (<Button className="ant-btn mi_button_icon"  onClick={() => this.CloseDiscussion(tag.discussionId)} style={{ marginRight: "-1px" }}><i className="fa fa-trash fa-red " ></i></Button>
                          )}  */}
                          {!tag.hasAccess ? (<></>) : (<Button className="ant-btn mi_button_icon"  onClick={() => this.CloseDiscussion(tag.discussionId)} style={{ marginRight: "-1px" }}><i className="fa fa-window-close" ></i></Button>
                          )}                       
                          {!tag.hasAccess ? (<></>) : (<Button className="ant-btn mi_button_icon" onClick={() => this.EditDiscussion(tag)} style={{ marginRight: "-1px" }}><i className="fa fa-pencil mi_icon" ></i></Button>
                          )}
                         
                        </Col>}  
                      </Row>
                      <Collapse lo style={{ backgroundColor: 'white', marginLeft: '-5px' }}>
                        <p className="mi_table_title" style={{ marginBottom: '-8px', marginLeft: '2px' }}>Replies</p>
                        <Panel key="1">

                          {tag.replies && tag.replies.length > 0 ? tag.replies.map(x => {
                            return <Comment style={{ backgroundColor: "white", padding: '0px 10px 0px 10px', border: '1px solid whitesmoke', borderRadius: '10px', marginBottom: '4px' }}

                              author={<a style={{ fontWeight: 'bold', fontSize: '18px', color: ' rgba(0, 0, 0, 0.65)' }}>{x.user}</a>}
                              avatar={
                                <Avatar
                                  alt="Han Solo"
                                  style={{ backgroundColor: '#4e5694' }}
                                >{x.user.split(' ').map((item) => item.charAt(0)).join('').toUpperCase()}</Avatar>
                              }
                              content={
                                <div>
                                  <Row>
                                    <Col span={20}>
                                      <p className="ant-table-column-title" dangerouslySetInnerHTML={{ __html: x.description }}>
                                      </p>
                                    </Col>
                                    {!tag.isClosed&& <Col span={4}>
                                      {/* {!x.hasAccess ? (<></>) : (<Button className="ant-btn mi_button_icon" onClick={this.EditReply}><i className="fa fa-pencil mi_icon" ></i>
                                    </Button>)} */}
                                    
                                      {!x.hasAccess ? (<></>) : (<Button className="ant-btn mi_button_icon" onClick={() => this.removeReply(x.id)} style={{ marginRight: "-1px" }}><i className="fa fa-trash fa-red " ></i></Button>
                                      )}
                                    </Col>}
                                   
                                  </Row>
                                </div>
                              }
                              datetime={
                                <Tooltip title={moment(x.createdOn).format('YYYY-MM-DD HH:mm:ss')}>
                                  <span style={{ fontWeight: '400px', color: ' rgba(0, 0, 0, 0.65)', fontSize: '14px' }} >{moment(x.createdOn).fromNow()}</span>
                                </Tooltip>
                              }
                            />
                          }) : <><Empty /></>}
                          {!tag.isClosed&&
                          <Row span={24} style={{ backgroundColor: 'whitesmoke', marginLeft: "2px", borderRadius: "10px", padding: "10px", marginBottom: "5px", marginTop: "5px", marginRight: '1px' }}>
                          
                            <ReactQuill
                              border='-1px solid #ccc'
                              value={this.state.addReply}                            
                              onChange={(input) => {
                                this.setState({
                                  addReply: input,
                                });
                              }}
                              
                              placeholder={"Text your message"}
                              modules={Discussion.modules}
                              formats={Discussion.formats}
                            />
                          </Row>}
                          {!tag.isClosed&&
                          <Row span={24} style={{ marginTop: "20px" }}>
                            <Button style={{ float: "right", backgroundColor: 'darkslateblue', color: 'white', marginTop: "-13px", width: "70px", marginRight: "0px" }}
                              onClick={() => this.addReplySubmitHandler({ discussionId: tag.discussionId, description: this.state.addReply })} >Post</Button></Row>
                          }
                        </Panel>
                      </Collapse>
                    </div>
                  }
                  datetime={
                    <Tooltip title={moment(tag.createdOn).format('YYYY-MM-DD HH:mm:ss')}>
                      <p style={{ fontWeight: '400px', color: ' rgba(0, 0, 0, 0.65)', fontSize: '14px',marginTop:"5px" }}>{moment(tag.createdOn).fromNow()}</p>
                    </Tooltip>
                  }
                />
              }) : <><Skeleton avatar paragraph={{ rows: 4 }} /><Skeleton avatar paragraph={{ rows: 4 }} /></>}
            </div>
          </Content>
          {this.state.addDiscussionActive ? (
            <Modal
              visible={this.state.addDiscussionActive}
            >
              <Adddiscussion
                closeDrawerHandler={this.addDiscussionDefaultHandler}
                submitHandler={this.addDiscusionSubmitHandler}
                width={500}
                discussion={this.state.discussion}
                userPermandMasters={this.props.userPermandMasters}
                title="Add Discussion"
              />
            </Modal>
          ) : null}
        </div>
      </Content>
    );
  }
}
Discussion.modules = {
  toolbar: [
    [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' },
    { 'indent': '-1' }, { 'indent': '+1' }],
    ['link', 'image'],
    ['clean']
  ],
}

Discussion.formats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
  'link', 'image'
]
